(function(){
  function boot(){
(function(){
  var input=document.getElementById('cat-filter-input');
  if(!input) return;
  var page=document.querySelector('.cats-page');
  var sections=Array.prototype.slice.call(document.querySelectorAll('.cat-section'));
  var noResults=document.getElementById('no-cats-found');
  var countEl=document.getElementById('cat-filter-count');
  var items=Array.prototype.slice.call(document.querySelectorAll('.cat-item'));
  var navLinks=Array.prototype.slice.call(document.querySelectorAll('.cat-nav a'));
  var total=items.length;

  // remember each label and its group total once, so highlighting is reversible
  items.forEach(function(it){
    var a=it.querySelector('a');
    it._label=a.textContent.trim();
    it._link=a;
  });
  var navFor={};
  navLinks.forEach(function(l){
    var id=decodeURIComponent(l.getAttribute('href').slice(1));
    navFor[id]=l;
    var s=l.querySelector('span');
    l._count=s; l._total=s?s.textContent.trim():'';
  });

  function paint(a,label,q){
    while(a.firstChild) a.removeChild(a.firstChild);
    if(!q){ a.appendChild(document.createTextNode(label)); return; }
    var lo=label.toLowerCase(), i=0, at;
    while((at=lo.indexOf(q,i))!==-1){
      if(at>i) a.appendChild(document.createTextNode(label.slice(i,at)));
      var mk=document.createElement('mark');
      mk.appendChild(document.createTextNode(label.slice(at,at+q.length)));
      a.appendChild(mk);
      i=at+q.length;
    }
    if(i<label.length) a.appendChild(document.createTextNode(label.slice(i)));
  }

  function updateCount(v,q){
    if(!countEl) return;
    countEl.textContent = q ? (v===0 ? 'No matches for \u201c'+q+'\u201d'
                                     : v+(v===1?' category matches \u201c':' categories match \u201c')+q+'\u201d')
                            : v+' of '+total+' categories';
  }
  updateCount(total,'');

  navLinks.forEach(function(link){
    link.addEventListener('click',function(e){
      var t=document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
      if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'});
             history.pushState(null,'',link.getAttribute('href')); }
    });
  });

  function run(){
    var q=input.value.trim().toLowerCase(), visible=0;
    page.classList.toggle('is-filtering', q.length>0);
    sections.forEach(function(section){
      var n=0;
      Array.prototype.slice.call(section.querySelectorAll('.cat-item')).forEach(function(item){
        var match = !q || item._label.toLowerCase().indexOf(q)!==-1;
        item.style.display = match ? '' : 'none';
        if(match){ n++; visible++; paint(item._link,item._label,q); }
      });
      section.style.display = n>0 ? '' : 'none';
      var link=navFor[section.id];
      if(link){
        link.classList.toggle('is-empty', n===0);
        if(link._count) link._count.textContent = q ? String(n) : link._total;
      }
    });
    noResults.style.display = visible===0 ? 'block' : 'none';
    updateCount(visible,q);
  }

  input.addEventListener('input',run);
  input.addEventListener('search',run);   // native clear button on type=search
})();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
